module.exports = __webpack_public_path__ + "img/home-image.b277a721.png";